export const TRACKING_URL_ACL_OBJECTS = [
    'TrackingUrl'
];
